import React, { useRef } from 'react';

import { NumericInputWrapper, ButtonWrapper, Input, Icon24 } from './styles';

const AutofillNumericInput = props => {
  const {
    onMinusClick,
    onInputChange,
    onPlusClick,
    value, className,
    backgroundColor,
    hoverColor,
    selectedColor,
    iconMinus,
    iconPlus,
    borderRadius = '0px'
  } = props;
  const inputRef = useRef(null);

  const handleInput = e => {
    if (e.target.value) {
      const value = e.target.value.replace(/[^-?\d*]/g, '');
      const valid = /^(-?|0|00|-?0[1-9]|-?[1-9]\d*)$/.test(value);
      if (valid) {
        onInputChange(value);
      }
    } else {
      onInputChange('');
    }
  };

  const handleFocus = () => {
    inputRef.current?.select();
  };

  return (
    <NumericInputWrapper className={className} $backgroundColor={backgroundColor} $borderRadius={borderRadius}>
      <ButtonWrapper onClick={onMinusClick}>
        <Icon24 $hoverBoxShadow src={iconMinus} />
      </ButtonWrapper>
      <Input
        ref={inputRef}
        className={className}
        type="text"
        value={value}
        $hoverColor={hoverColor}
        $selectedColor={selectedColor}
        $backgroundColor={backgroundColor}
        onFocus={handleFocus}
        onChange={handleInput}
      />
      <ButtonWrapper onClick={onPlusClick}>
        <Icon24 $hoverBoxShadow src={iconPlus} />
      </ButtonWrapper>
    </NumericInputWrapper>
  );
};

export default AutofillNumericInput;
